module.exports = __webpack_public_path__ + "static/media/9-7.2079ce8a.mp3";